import { useEffect, useState } from 'react'
import { DeskHeader } from './desk-header';
import { MobileHeader } from './mobile-header';

const BREAKPOINT_DESKTOP = 1008
const BREAKPOINT_MOBILE = 992
const RESIZE_DEBOUNCE_MS = 200

export const Header = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000)

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null

    const handleResize = () => {
      if (timeoutId) clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        const width = window.innerWidth
        setIsMobile(prev => {
          if (width >= BREAKPOINT_DESKTOP) return false
          if (width <= BREAKPOINT_MOBILE) return true
          return prev
        })
        timeoutId = null
      }, RESIZE_DEBOUNCE_MS)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [])

  return isMobile ? <MobileHeader /> : <DeskHeader />
}
